'use client';

import NextImage from 'next/image';
import { useEffect, useRef } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import style from './GallerySlideModalInner.module.scss';
const GallerySlideModalInner = ({
  url,
  scale
}) => {
  const ref = useRef();
  const element = ref?.current?.instance?.contentComponent;
  element?.setAttribute('id', url);
  useEffect(() => {
    element?.setAttribute('id', url);
  }, []);
  const getNameForAlt = url_0 => {
    const filenameWithExtension = url_0.slice(url_0.lastIndexOf('/') + 1);
    const filename = filenameWithExtension.split('.')[0];
    return filename;
  };
  return <>
      <TransformWrapper doubleClick={{
      mode: scale > 1.1 ? 'zoomOut' : 'zoomIn'
    }} ref={ref}>
        {() => <TransformComponent>
            <span className={style.imgWrapper}>
              <NextImage className={style.img} src={url} alt={getNameForAlt(url)} />
            </span>
          </TransformComponent>}
      </TransformWrapper>
    </>;
};
export default GallerySlideModalInner;